import type { RequestPayload } from "@inertiajs/core";
import { router, usePage } from "@inertiajs/react";
import { Button, Container, Flex, Paper, Stack, TextInput, Title } from "@mantine/core";
import { useForm } from "@mantine/form";
import { user_password_path } from "../../routes";

type FormErrors = {
  email?: string[];
};

export default function PasswordReset() {
  const { errors } = usePage<{ errors: FormErrors }>().props;

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      user: {
        email: "",
      },
    },
  });

  const onSubmit = (values: RequestPayload) => router.post(user_password_path(), values);

  return (
    <Container fluid mt="4rem">
      <Flex justify="center" align="center">
        <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
          <Paper shadow="sm" p="lg" withBorder w="40rem" maw="40rem">
            <Stack>
              <Title order={2}>Passwort zurücksetzen</Title>
              <TextInput
                type="email"
                label="E-Mail"
                key={form.key("user.email")}
                {...form.getInputProps("user.email")}
                error={errors?.email}
              />
              <Button type="submit">E-Mail senden</Button>
            </Stack>
          </Paper>
        </form>
      </Flex>
    </Container>
  );
}
